// Save form state every second
// to reduce load on Redux store
export const FORM_PRESERVATION_DELAY = 1000;

// Delay before recovering form state
// in order to not interrupt UI transitions
export const FORM_RECOVER_DELAY = 2000;
